import { NavLink } from "react-router-dom"
import isLoggedIn from "./isLoggedIn";

const NavbarNew = () => {
  const navigate = path => {
    // <NavLink/
  }
  return isLoggedIn() ? (
    <div className="navbar-container ">
      <div className="d-flex options ">
        <NavLink className="option text-center p-10" to="/home">
          <img
            src="https://i.postimg.cc/ZYvjRCFy/icons8-dashboard-48.png"
            alt="home"
          />

          <span className="subtext">- General</span>
        </NavLink>
        <NavLink className="option text-center p-10" to="/journey">
          <div className="">
            <img
              src="https://i.postimg.cc/662hLJLn/icons8-timeline-64.png"
              alt="journey"
            />
            <span className="subtext">- Major Events</span>
          </div>
        </NavLink>
        <NavLink className="option text-center p-10" to="/letters">
          <img
            src="https://i.postimg.cc/bvnkZMD8/icons8-page-64-1.png"
            alt="letters"
          />
          <span className="subtext">- Letters</span>
        </NavLink>
      </div>
      {/* <div className="option  p-10"> Letters
                <span className="subtext left-50">Letters</span> </div> */}
    </div>
  ): <></>
}

export default NavbarNew;
